(function(){
  if(window.__bcApple)return;window.__bcApple=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var els=document.querySelectorAll('.bc [data-bc-reveal]');
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -12% 0px'});
    els.forEach(function(e){io.observe(e)});
    var stages=document.querySelectorAll('.bc-hero__stage');if(!stages.length)return;
    var ticking=false;
    function upd(){ticking=false;var vh=window.innerHeight;stages.forEach(function(s){var r=s.getBoundingClientRect();var p=Math.min(1,Math.max(0,(vh-r.top)/(vh*0.9)));s.style.setProperty('--bc-i',((1-p)*7).toFixed(2)+'%')})}
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd)}},{passive:true});
    window.addEventListener('resize',upd);upd();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){window.__bcApple=0;init()});
})();
